<template>
    <div class="linked-account">
        <transition name="linked-account-fade" mode="out-in">
            <view-account-link
                v-if="!edit"
                key="view"
                :value="linkedAccount"
                v-bind="$attrs"
                edit
                @edit="edit = true"
            />
            <edit-account-link
                v-else
                key="edit"
                :value="linkedAccount"
                v-bind="$attrs"
                @save="save"
                @completed="completed"
                @cancel="cancel"
            />
        </transition>
    </div>
</template>

<script>
import ViewAccountLink from './view_account_link'
import EditAccountLink from './edit_account_link'
import gql from 'graphql-tag'
import Vue from 'vue'

export default Vue.extend({
    name: 'AccountLinkedAccountRoot',
    components: {
        ViewAccountLink,
        EditAccountLink
    },
    inheritAttrs: false,
    apollo: {
        accountLinking: {
            query: gql`
                query accountLinking {
                    accountLinking {
                        oldEmail
                        verified
                        createdAt
                        verifiedAt
                    }
                }
            `
        }
    },
    data() {
        return {
            edit: false
        }
    },
    computed: {
        linkedAccount() {
            return this.accountLinking
                ? {
                      email: this.accountLinking.oldEmail,
                      completed: this.accountLinking.verified,
                      createdAt: this.accountLinking.createdAt,
                      verifiedAt: this.accountLinking.verifiedAt
                  }
                : []
        }
    },
    methods: {
        save() {
            this.$apollo.queries.accountLinking.refetch() // always refetch to update state after changes are potentially made
            this.$auth.loadUserProfile() // always reload user profile when changes are potentially made
        },
        completed() {
            this.save()
            this.edit = false
        },
        cancel() {
            this.edit = false
        }
    }
})
</script>

<style scoped>
.linked-account {
    min-width: 0;
}
.linked-account-fade-enter-active,
.linked-account-fade-leave-active {
    transition: opacity 150ms ease, transform 150ms ease;
}
.linked-account-fade-enter,
.linked-account-fade-leave-to {
    opacity: 0;
    transform: translateY(4px);
}
@media (prefers-reduced-motion: reduce) {
    .linked-account-fade-enter-active,
    .linked-account-fade-leave-active {
        transition: none;
    }
}
</style>
